import { useCallback } from 'react';
import useApi from './useApi';
import { useAppSettings } from '../hooks/useAppSettings';
import { ProductListItem } from '../types/ProductTypes';

export default () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();

    const getProductsByDraegerTube = useCallback(
        async (draegerTubeId: number) => {
            try {
                const apiUrl = appSettings?.api;
                if (!apiUrl) {
                    throw new Error('API URL not configured in app settings');
                }
                const response = await getApiData({
                    endpoint: `${apiUrl}/QueryProductMetaData?draegerTubeId=${draegerTubeId}`,
                });
                return response;
            } catch (error) {
                console.error(`Failed to fetch products for draeger tube ID ${draegerTubeId}:`, error);
                throw error;
            }
        },
        [getApiData, appSettings]
    );

    // Extract products from the items key in the response (camelCase from API)
    const products = state.result?.items as ProductListItem[] | null;

    return {
        products,
        loading: state.isLoading,
        error: state.error,
        getProductsByDraegerTube,
    };
};
